import { CopyToClipboard } from 'react-copy-to-clipboard';
import { InsertLink } from '@mui/icons-material';
import { useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/joy';

const CopyToClipboardUtility = () => {
	const [copied, setCopied] = useState(false);
	const theme = useTheme();

	// const getLink = () => {
	// 	if (location.href.includes('#')) {
	// 		const link = location.href.split('#')[0];
	// 		return `${link}#${anchor}`;
	// 	} else return `${location.href}#${anchor}`;
	// };
	// const link = getLink();
	return (
		<Box sx={{ position: 'relative' }}>
			{copied ? (
				<span
					style={{
						position: 'absolute',
						top: '-1.5rem',
						left: '1rem',
						fontSize: '1rem',
						fontFamily: 'Source Sans Pro'
					}}
				>
					link copied!
				</span>
			) : null}

			<CopyToClipboard text={location} onCopy={() => setCopied(true)}>
				<Button
					sx={{
						backgroundColor: 'transparent',
						//paddingRight: 0,
						'&:hover': {
							backgroundColor:
								theme.colorSchemes.light.palette.chartElementsBackground.bg
						},
						'.MuiSvgIcon-root': {
							fill: theme.colorSchemes.light.palette.chartElementsBackground
								.baseLine,
							fontSize: '1.75rem'
						}
					}}
				>
					<Typography level='label' sx={{ marginRight: '.5rem' }}>
						Copy Link
					</Typography>
					<InsertLink />
				</Button>
			</CopyToClipboard>
		</Box>
	);
};
export default CopyToClipboardUtility;
